// extracted by mini-css-extract-plugin
export var active = "_ie-2";
export var recordingDot = "_ie-1";
export var recordingIndicator = "_ie-0";